import { render } from "./UnderMaintenance.vue?vue&type=template&id=22fc72c8&scoped=true"
import script from "./UnderMaintenance.vue?vue&type=script&lang=js"
export * from "./UnderMaintenance.vue?vue&type=script&lang=js"

import "./UnderMaintenance.vue?vue&type=style&index=0&id=22fc72c8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fc72c8"]])

export default __exports__